/* istanbul ignore file: todo tests @titk */

/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/unbound-method */
import React, {CSSProperties, RefObject} from 'react';
import _ from 'lodash';
import a11y from '@wix/wixstores-client-core/dist/es/src/assets/styles/_accessibility.scss';
import {classes as quantityStyle, style as styleQuantity} from './QuantityCounter.st.css';
import autobind from 'auto-bind-es5';
import classNames from 'classnames';
import s from './ProductItem.scss';
import {classes as productItemStylable, st as productItemStyles} from './ProductItem.st.css';
import {Counter, StatesButton, Text} from 'wix-ui-tpa';
import {IGalleryGlobalProps} from '../../../gallery/galleryGlobalStrategy';
import {Alignments, ImagePositions, IProduct, RibbonPlacementId, VerticalAlignments} from '../../../types/galleryTypes';
import {ProductImageOLD} from './ProductImageOLD/ProductImageOLD';
import {ProductPrice} from './ProductPrice/ProductPrice';
import {QuantityCalculator} from '@wix/wixstores-client-core/dist/es/src/quantity-calculator/quantityCalculator';
import {withGlobals} from '../../../globalPropsContext';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {Announcer} from '@wix/wixstores-client-core/dist/es/src/a11y/announcer';
import {ActionStatus} from '@wix/wixstores-client-core/dist/es/src/constants';
import {ProductOptionsChangeData, ProductOptionsWithGlobals} from './ProductOptions/ProductOptions';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {ProductOptionType} from '@wix/wixstores-graphql-schema';
import {ProductMedia} from './ProductMedia/ProductMedia';
import {ProductRibbon} from './Ribbon/Ribbon';
import {AddToCartButton as AddToCart} from './AddToCartButton/AddToCartButton';

export enum DataHook {
  AddToCartButton = 'product-item-add-to-cart-button',
  LineBetweenNameAndPrice = 'product-item-line-between-name-and-price',
  LinkContainer = 'product-item-container',
  Name = 'product-item-name',
  Price = 'product-item-price',
  ProductDetails = 'product-item-product-details',
  ProductDetailsLink = 'product-item-product-details-link',
  QuantityCounter = 'product-item-quantity-counter',
  QuantityCounterWrapper = 'product-item-quantity-counter-wrapper',
  QuickViewButton = 'product-item-quick-view-button',
  Ribbon = 'product-item-ribbon',
  Root = 'product-item-root',
  SrOnlyName = 'product-item-sr-only-name',
  Options = 'product-item-options',
  NotImageContainer = 'not-image-container',
}

export interface IProductItemProps extends IGalleryGlobalProps {
  a11yAnnouncer: Announcer;
  index: number;
  product: IProduct;
  innerRef?: Function;
  disabled?: boolean;
  style?: CSSProperties;
}

interface IProductItemState {
  errors: {quantity?: string};
  limits: {quantity: {min: number; max: number}};
  selections: number[];
  quantity: number;
  showHoverPreview: boolean;
  isHovered: boolean;
}

const PREVIEW_DURATION = 1000;

export class ProductItem extends React.Component<IProductItemProps & IProvidedTranslationProps, IProductItemState> {
  private readonly debouncedStopHoverPreview = _.debounce(
    () => this.setState({showHoverPreview: false}),
    PREVIEW_DURATION
  );
  private readonly productLink = React.createRef<HTMLAnchorElement>();
  public addToCartButtonRef: RefObject<StatesButton> = React.createRef();
  public state: IProductItemState = {
    isHovered: false,
    showHoverPreview: false,
    quantity: 1,
    selections: [],
    errors: {quantity: undefined},
    limits: {
      quantity: {
        min: 1,
        max: 1,
      },
    },
  };

  constructor(props) {
    super(props);
    autobind(this);
  }

  public static getDerivedStateFromProps(props: IProductItemProps): Partial<IProductItemState> {
    const inventoryRange = QuantityCalculator.getQuantitiesRange(props.product);
    const inventoryCount = inventoryRange[inventoryRange.length - 1];

    return {
      limits: {
        quantity: {
          min: 1,
          max: inventoryCount,
        },
      },
    };
  }

  public focus(): void {
    this.productLink.current.focus();
  }

  private renderSrOnlyName() {
    return (
      <span data-hook={DataHook.SrOnlyName} className={a11y.srOnly}>
        {this.props.product.name}
      </span>
    );
  }

  private renderName() {
    const {
      product,
      globals: {shouldShowMobile},
    } = this.props;
    const htmlTag = this.props.globals.htmlTags.productNameHtmlTag;
    const classes = classNames(
      productItemStyles(productItemStylable.root, {
        useMobileFont: shouldShowMobile,
      }),
      s.productName
    );

    return (
      <Text tagName={htmlTag} className={classes} data-hook={DataHook.Name}>
        {product.name}
      </Text>
    );
  }

  private renderImage() {
    const {
      globals: {
        shouldShowMobile,
        imageMode,
        imageRatio,
        styleParams: {
          booleans: {showQuickView: shouldShowQuickViewButton},
          fonts: {
            gallery_hoverType: {value: hoverType},
          },
          numbers: {gallery_ribbonPlacement: ribbonPlacement},
        },
        textsMap: {digitalProductBadgeAriaLabelText},
        experiments: {newUiTpaImage},
      },
      product,
    } = this.props;

    const productWithCurrentMedia = this.shouldShowProductOptions
      ? {
          ...product,
          media: this.currentMedia,
        }
      : product;

    const ImageComponent = newUiTpaImage ? ProductMedia : ProductImageOLD;
    const shouldRenderRibbonOnImage = ribbonPlacement === RibbonPlacementId.OnImage;

    return (
      <ImageComponent
        classNames={{thumbnail: s.productThumbnail, image: s.productImage}}
        product={productWithCurrentMedia}
        isMobile={shouldShowMobile}
        hoverType={hoverType}
        imageRatioId={imageRatio}
        imageModeId={imageMode}
        textsMap={{digitalProductBadgeAriaLabel: digitalProductBadgeAriaLabelText}}>
        {shouldRenderRibbonOnImage ? this.renderRibbon() : null}
        {!shouldShowMobile && shouldShowQuickViewButton && this.renderQuickViewButton()}
      </ImageComponent>
    );
  }

  private renderPrice() {
    const {
      globals: {
        allowFreeProducts,
        textsMap: {
          productPriceBeforeDiscountSR,
          productOutOfStockText,
          productPriceAfterDiscountSR,
          productPriceWhenThereIsNoDiscountSR,
          measurementUnits,
          pricePerUnitSR,
        },
      },
      product,
    } = this.props;

    /* istanbul ignore next: todo tests @titk */
    const productWithPriceInfo = this.shouldShowProductOptions
      ? {
          ...product,
          ...this.productVariantInfo /* istanbul ignore next: todo tests @titk */?.priceInfo,
        }
      : product;

    return (
      <ProductPrice
        product={productWithPriceInfo}
        isAddtoCartButtonExists={this.props.globals.shouldShowAddToCartButton}
        allowFreeProducts={allowFreeProducts}
        textsMap={{
          productPriceBeforeDiscountSR,
          productOutOfStockText,
          productPriceAfterDiscountSR,
          productPriceWhenThereIsNoDiscountSR,
          measurementUnits,
          pricePerUnitSR,
        }}
        fromPrice={this.productPriceRange}
        priceBreakdown={this.props.globals.priceBreakdown}
        isRTL={this.props.globals.isRTL}
        isMobile={this.props.globals.shouldShowMobile}
        sendClickShippingInfoLinkSf={this.props.globals.sendClickShippingInfoLinkSf}
      />
    );
  }

  private static renderLineBetweenNameAndPrice() {
    return (
      <div className={s.productDividerWrapper}>
        <hr data-hook={DataHook.LineBetweenNameAndPrice} className={s.productDivider} aria-hidden="true" />
      </div>
    );
  }

  private renderQuickViewButton() {
    return (
      <button
        className={s.quickViewButton}
        data-hook={DataHook.QuickViewButton}
        tabIndex={-1}
        aria-hidden="true"
        onClick={this.handleQuickViewButtonClick}>
        {this.props.globals.textsMap.quickViewButtonText}
      </button>
    );
  }

  private renderRibbon() {
    const {
      product: {ribbon},
      globals: {
        shouldShowMobile,
        styleParams: {
          numbers: {gallery_ribbonPlacement: ribbonPlacement, gallery_ribbonType: ribbonType},
          booleans: {gallery_showRibbon: shouldShowRibbon},
        },
      },
    } = this.props;

    if (!shouldShowRibbon) {
      return null;
    }

    if (ribbon) {
      return (
        <ProductRibbon
          shouldShowMobile={shouldShowMobile}
          ribbon={ribbon}
          placement={ribbonPlacement}
          type={ribbonType}
        />
      );
    }

    return null;
  }

  private handleQuickViewButtonClick(event: React.MouseEvent<HTMLButtonElement>) {
    const {
      globals: {openQuickView},
      product: {id: productId},
      index,
    } = this.props;
    const {quantity} = this.state;
    const selectionIds = this.productVariantInfo?.variantSelectionIds || [];

    event.preventDefault();
    event.stopPropagation();

    openQuickView({productId, index, selectionIds, quantity});
  }

  private handleQuantityCounterChange(val: string) {
    const {t} = this.props;
    const {min, max} = this.state.limits.quantity;
    const quantity = parseInt(val, 10) || 0;

    const minimumError = quantity < min && t('quantityMinimumAmountSR', {minimum: min});
    const maximumError = quantity > max && t('quantityMaximumAmountSR', {inventory: max});

    this.setState(
      ({errors}) => {
        const nextErrors = {...errors, quantity: minimumError || maximumError};
        return {quantity, errors: nextErrors};
      },
      () => {
        if (this.state.errors.quantity) {
          this.props.a11yAnnouncer.announce(this.state.errors.quantity);
        } else {
          this.props.a11yAnnouncer.announce(
            this.props.t('quantityTotalSR', {
              quantity,
            })
          );
        }
      }
    );
  }

  private readonly handleSelectionsChange = (selections: number[], data: ProductOptionsChangeData) =>
    this.setState(
      {
        selections,
      },
      () => {
        const {
          props: {
            globals: {handleProductsOptionsChange},
            product: {id: productId},
          },
        } = this;

        const {optionType} = data;

        handleProductsOptionsChange({
          productId,
          selectionIds: selections,
          optionType,
        });
      }
    );

  private handleProductItemClick(event: React.MouseEvent<HTMLAnchorElement>) {
    const {
      globals: {handleProductItemClick},
      product: {id: productId},
      index,
      disabled,
    } = this.props;

    event.preventDefault();
    event.stopPropagation();

    if (disabled) {
      return;
    }
    handleProductItemClick({
      biData: {
        productId,
        index,
      },
    });
  }

  public componentDidUpdate(prevProps: Readonly<IProductItemProps>): void {
    const {
      product,
      globals: {
        styleParams: {
          fonts: {
            gallery_hoverType: {value: previousHoverType},
          },
        },
        addedToCartStatus: prevAddedToCartStatus,
      },
    } = prevProps;
    const {
      globals: {
        styleParams: {
          fonts: {
            gallery_hoverType: {value: currentHoverType},
          },
        },
        addedToCartStatus,
        shouldShowAddToCartSuccessAnimation,
      },
      a11yAnnouncer,
      t,
    } = this.props;

    if (previousHoverType !== currentHoverType) {
      this.setState({showHoverPreview: true});

      this.debouncedStopHoverPreview();
    }

    const prevAddToCartStatus = prevAddedToCartStatus[product.id];
    const addToCartStatus = addedToCartStatus[product.id];

    if (
      shouldShowAddToCartSuccessAnimation &&
      prevAddToCartStatus !== ActionStatus.SUCCESSFUL &&
      addToCartStatus === ActionStatus.SUCCESSFUL
    ) {
      a11yAnnouncer.announce(t('addToCartSuccessSR', {productName: product.name}));
    }
  }

  private get isAddToCartEnabled() {
    const currentState = this.props.globals.productsManifest[this.props.product.id].addToCartState;
    const isEnabledState = currentState === AddToCartState.ENABLED;
    return isEnabledState || this.isPreOrderState;
  }

  private get shouldRenderQuantityCounter() {
    const {
      globals: {shouldShowAddToCartButton, shouldShowQuantity},
    } = this.props;

    const hasOptions = this.props.product.options.length > 0;
    const hasSingleOption =
      this.props.product.options.length === 1 ||
      this.props.product.options.every(({optionType}) => optionType === ProductOptionType.COLOR);

    return (
      shouldShowAddToCartButton &&
      shouldShowQuantity &&
      this.isAddToCartEnabled &&
      (!hasOptions || (this.shouldShowProductOptions && hasSingleOption))
    );
  }

  private get shouldShowProductOptions() {
    const {
      globals: {shouldShowProductOptions},
      product,
    } = this.props;
    return shouldShowProductOptions && (product.isInStock || this.isPreOrderState);
  }

  private get productVariantInfo() {
    const {
      globals: {productsVariantInfoMap},
      product,
    } = this.props;

    return productsVariantInfoMap?.[product.id];
  }

  private get productPriceRange(): string | undefined {
    const {
      globals: {productsPriceRangeMap},
      product,
    } = this.props;

    return productsPriceRangeMap?.[product.id];
  }

  private readonly getRevealClassNames = () => {
    if (this.props.globals.isOptionsRevealEnabled) {
      const hasOptions = this.props.product.options.length > 0;
      const hasSingleOption =
        this.props.product.options.length === 1 ||
        this.props.product.options.every(({optionType}) => optionType === ProductOptionType.COLOR);
      const hasSelections = this.productVariantInfo.variantSelectionIds.length > 0;
      const shouldBeHidden = hasOptions && hasSingleOption && !hasSelections;
      return {
        [s.hiddenModeHidden]: shouldBeHidden,
        [s.hiddenModeVisible]: !shouldBeHidden,
      };
    }
    return {};
  };

  private readonly renderQuantityCounter = () => {
    const {
      globals: {
        shouldShowMobile,
        styleParams: {
          booleans: {gallery_addToCartButtonShowOnHover: shouldShowAddToCartButtonShowOnHover},
        },
        textsMap,
      },
    } = this.props;

    const {
      quantity,
      limits: {
        quantity: {min, max},
      },
    } = this.state;

    const errors = {
      error: !!this.state.errors.quantity,
      errorMessage: this.state.errors.quantity,
    };

    return (
      <div className={classNames(s.quantity, this.getRevealClassNames())} data-hook={DataHook.QuantityCounterWrapper}>
        <Counter
          {...errors}
          decrementAriaLabel={textsMap.quantityRemoveSR}
          incrementAriaLabel={textsMap.quantityAddSR}
          aria-label={textsMap.quantityChooseAmountSR}
          inputAriaLabel={textsMap.quantityInputSR}
          onChange={this.handleQuantityCounterChange}
          data-hook={DataHook.QuantityCounter}
          value={quantity}
          min={min}
          max={max}
          className={classNames(
            styleQuantity(quantityStyle.quantityCounter, {
              customized: true,
            }),
            {
              [s.showOnHover]: shouldShowAddToCartButtonShowOnHover && !shouldShowMobile,
            }
          )}
        />
      </div>
    );
  };

  public renderOptions = () => {
    const {product} = this.props;

    return (
      <div data-hook={DataHook.Options}>
        <ProductOptionsWithGlobals
          variantsAvailability={this.productVariantInfo.selectionsAvailability}
          onSelectionIdsChange={this.handleSelectionsChange}
          product={product}
          selectionIds={this.productVariantInfo.variantSelectionIds}
          isItemHovered={this.state.isHovered}
        />
      </div>
    );
  };

  private get isPreOrderState(): boolean {
    const {
      globals: {
        experiments: {isPreOrderEnabled},
      },
    } = this.props;
    const {addToCartState} = this.props.globals.productsManifest[this.props.product.id];
    return isPreOrderEnabled && addToCartState === AddToCartState.PRE_ORDER;
  }

  private get currentMedia() {
    const {product} = this.props;

    return this.productVariantInfo?.mediaItems ?? product.media;
  }

  private get verticalAlignmentClass() {
    const {gallery_verticalAlignment} = this.props.globals.styleParams.fonts;
    switch (gallery_verticalAlignment?.value) {
      case VerticalAlignments.TOP:
        return s.verticalAlignmentTop;
      case VerticalAlignments.BOTTOM:
        return s.verticalAlignmentBottom;
      case VerticalAlignments.STRETCH:
        return s.verticalAlignmentStretch;
    }
  }

  public onAddToCartClicked = () => {
    this.setState({quantity: 1});
  };

  public renderAddToCartButton = () => {
    const {product, index} = this.props;
    const {quantity} = this.state;

    const {
      shouldShowMobile,
      experiments: {isPreOrderEnabled},
      styleParams: {
        booleans: {gallery_addToCartButtonShowOnHover: shouldShowOnHover},
        fonts: {
          gallery_addToCartButtonWidth: {value: buttonWidth},
        },
      },
      addedToCartStatus,
      handleAddToCart,
      updateAddToCartStatus,
      productsManifest,
      textsMap: {
        galleryAddToCartButtonText,
        addToCartContactSeller,
        addToCartOutOfStock,
        galleryAddToCartPreOrderButtonText,
      },
      shouldShowAddToCartSuccessAnimation,
    } = this.props.globals;

    return (
      <AddToCart
        product={product}
        index={index}
        quantity={quantity}
        onAddToCartClicked={this.onAddToCartClicked}
        showOnHoverClassName={s.showOnHover}
        isPreOrderEnabled={isPreOrderEnabled}
        addedToCartStatus={addedToCartStatus}
        addToCartState={productsManifest[this.props.product.id].addToCartState}
        handleAddToCart={handleAddToCart}
        updateAddToCartStatus={updateAddToCartStatus}
        galleryAddToCartButtonText={galleryAddToCartButtonText}
        addToCartContactSeller={addToCartContactSeller}
        addToCartOutOfStock={addToCartOutOfStock}
        galleryAddToCartPreOrderButtonText={galleryAddToCartPreOrderButtonText}
        shouldShowAddToCartSuccessAnimation={shouldShowAddToCartSuccessAnimation}
        shouldShowMobile={shouldShowMobile}
        shouldShowOnHover={shouldShowOnHover}
        buttonWidth={buttonWidth}
      />
    );
  };

  private get shouldShowImageOnRight() {
    const {
      index,
      globals: {isHorizontalLayout, imagePosition, shouldAlternateImagePosition},
    } = this.props;

    if (!isHorizontalLayout) {
      return false;
    }

    const oddProductItemIndex = index % 2;
    if (shouldAlternateImagePosition) {
      return imagePosition === ImagePositions.LEFT ? oddProductItemIndex : !oddProductItemIndex;
    }

    return imagePosition === ImagePositions.RIGHT;
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  public render() {
    const {
      globals: {
        isRTL,
        shouldShowMobile,
        isLiveSiteMode,
        isPreviewMode,
        isHorizontalLayout,
        productsManifest,
        shouldShowAddToCartButton,
        experiments: {isAllowGalleryProductRoundCornersInViewer, isCustomizePaddingEnabled},
        styleParams: {
          booleans: {
            gallery_showPrice: shouldShowPrice,
            gallery_showProductName: shouldShowName,
            gallery_showDividers: shouldShowLineBetweenNameAndPrice,
          },
          fonts: {
            gallery_hoverType: {value: hoverType},
            gallery_alignment: {value: alignment},
          },
          numbers: {gallery_ribbonPlacement: ribbonPlacement},
        },
      },
      product,
      style,
      t,
    } = this.props;
    if (!productsManifest[product.id]) {
      return null;
    }

    const {showHoverPreview} = this.state;
    const shouldShowProductDetails = shouldShowName || shouldShowLineBetweenNameAndPrice || shouldShowPrice;
    const productPageUrl = productsManifest[product.id].url;
    const shouldRenderRibbonInProductInfo = ribbonPlacement === RibbonPlacementId.ProductInfo;
    const shouldAlignStart = (alignment === Alignments.LEFT && !isRTL) || (alignment === Alignments.RIGHT && isRTL);
    const shouldAlignEnd = (alignment === Alignments.RIGHT && !isRTL) || (alignment === Alignments.LEFT && isRTL);
    const ariaLabelBase = product.name;
    const ariaLabel = product.ribbon ? `${ariaLabelBase}. ${product.ribbon}` : ariaLabelBase;

    return (
      <div
        role="group"
        aria-label={t('carouselContainerLabel', {productName: ariaLabel})}
        onMouseEnter={() => this.setState({isHovered: true})}
        onMouseLeave={() => this.setState({isHovered: false})}
        style={style}
        data-hook={DataHook.Root}
        className={classNames(s.productItem, shouldShowMobile ? s.none : s[hoverType], {
          [s.hoverPreview]: showHoverPreview,
          [s.productOptions]: this.shouldShowProductOptions,
          [s.roundCorners]: isAllowGalleryProductRoundCornersInViewer,
          [s.horizontalLayout]: isHorizontalLayout,
          [s.imageOnRight]: this.shouldShowImageOnRight,
          [s.isRTL]: isRTL,
        })}>
        <a
          href={isLiveSiteMode || isPreviewMode ? productPageUrl : null}
          tabIndex={-1}
          onClick={this.handleProductItemClick}
          className={classNames(s.productItemLink, {
            [s.customizePadding]: isCustomizePaddingEnabled,
          })}
          data-hook={DataHook.LinkContainer}>
          {this.renderImage()}
        </a>
        <div
          data-hook={DataHook.NotImageContainer}
          className={classNames(s.notImageContainer, {
            [this.verticalAlignmentClass]: isHorizontalLayout,
          })}>
          <a
            href={isLiveSiteMode || isPreviewMode ? productPageUrl : null}
            onClick={this.handleProductItemClick}
            className={s.productDetailsLink}
            data-hook={DataHook.ProductDetailsLink}
            ref={this.productLink}>
            {!shouldShowName && this.renderSrOnlyName()}
            {shouldShowProductDetails && (
              <div
                className={classNames(
                  s.productDetails,
                  {[s.alignCenter]: alignment === Alignments.CENTER},
                  {[s.alignStart]: shouldAlignStart},
                  {[s.alignEnd]: shouldAlignEnd}
                )}
                data-hook={DataHook.ProductDetails}>
                {shouldRenderRibbonInProductInfo ? this.renderRibbon() : null}
                {shouldShowName && this.renderName()}
                {shouldShowLineBetweenNameAndPrice && ProductItem.renderLineBetweenNameAndPrice()}
                {shouldShowPrice && this.renderPrice()}
              </div>
            )}
          </a>

          {this.shouldShowProductOptions && (
            <div className={s.productInputs}>
              {this.renderOptions()}
              {this.shouldRenderQuantityCounter && this.renderQuantityCounter()}
            </div>
          )}

          {shouldShowAddToCartButton && (
            <div className={s.productFooter}>
              {this.shouldRenderQuantityCounter && !this.shouldShowProductOptions && this.renderQuantityCounter()}
              {this.renderAddToCartButton()}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export const ProductItemWithGlobals = withGlobals(withTranslations()(ProductItem));
